import type { FC, PropsWithChildren } from 'react';
import React from 'react';

import type { CreateCampaignProviderProps } from './CreateCampaignProvider';
import { CreateCampaignProvider } from './CreateCampaignProvider';
import type { CreateCommunityProviderProps } from './CreateCommunityProvider';
import { CreateCommunityProvider } from './CreateCommunityProvider';
import type { CreatePostProviderProps } from './CreatePostProvider';
import { CreatePostProvider } from './CreatePostProvider';

export type UniversalCreateButtonProviderProps = CreateCommunityProviderProps &
  CreateCampaignProviderProps &
  CreatePostProviderProps;

export const UniversalCreateButtonProvider: FC<PropsWithChildren<UniversalCreateButtonProviderProps>> = ({
  useGroupCreateModal,
  campaignCreateModal,
  usePostCreateModal,
  children,
}) => (
  <CreateCommunityProvider useGroupCreateModal={useGroupCreateModal}>
    <CreateCampaignProvider campaignCreateModal={campaignCreateModal}>
      <CreatePostProvider usePostCreateModal={usePostCreateModal}>{children}</CreatePostProvider>
    </CreateCampaignProvider>
  </CreateCommunityProvider>
);
